import { DataForSearchTour } from 'entities/tour/models/search-tour'

export const getTouristCount = (data: DataForSearchTour | undefined) => {
  return (data?.passengers?.adults || 0) + (data?.passengers?.children || 0)
}
